<template lang="html">
<div>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">쿠폰구분</b-col>
    <b-col sm="5">
      <b-form-group>
        <b-form-radio-group v-model="couponDetail.coupon_type">
          <b-form-radio value="CT_1">할인쿠폰</b-form-radio>
          <!-- <b-form-radio value="CT_2">기간제쿠폰</b-form-radio> -->
        </b-form-radio-group>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">쿠폰명</b-col>
    <b-col sm="5">
      <b-form-input v-if="newFlag == 'new'" v-model="couponDetail.coupon_name" placeholder=""
        name="couponnameVali" :class="{error: errors.has(couponnameVali)}" v-validate="'required'"
      ></b-form-input>
      <b-form-input v-if="newFlag == 'edit'" v-model="couponDetail.coupon_name" placeholder="" readonly></b-form-input>
    </b-col>
    </b-col>
  </b-row>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">쿠폰설명</b-col>
    <b-col sm="5">
      <b-form-input v-if="newFlag == 'edit'" v-model="couponDetail.coupon_desc" placeholder="" readonly></b-form-input>
      <b-form-textarea
        id="textarea"
        v-model="couponDetail.coupon_desc"
        placeholder=""
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-col>
  </b-row>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">발행수량</b-col>
    <b-col sm="5">
      <b-form-input v-model="couponDetail.coupon_cnt" placeholder="" type="number"
        name="couponpubcntVali" :class="{error: errors.has(couponpubcntVali)}" v-validate="'required'"
      ></b-form-input>
    </b-col>
  </b-row>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">발행일</b-col>
    <b-col sm="5">
      <b-form-input v-model="couponDetail.start_date" placeholder="" readonly></b-form-input>
    </b-col>
  </b-row>
  <b-row class="pb-2">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">만료일</b-col>
    <b-col sm="5">
      <b-form-input type="text" name="expired" v-model="couponDetail.end_date" />
    </b-col>
  </b-row>
  <b-row class="pb-2" v-if="couponDetail.coupon_type == 'CT_1'">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">할인율</b-col>
    <b-col sm="4">
      <b-form-input  v-model="couponDetail.opt_value"></b-form-input>
    </b-col>
    <b-col sm="1">%</b-col>
  </b-row>
  <b-row class="pb-2" v-if="couponDetail.coupon_type == 'CT_2'">
    <b-col sm="1"></b-col>
    <b-col sm="2" class="mt-1 formLabel">기간</b-col>
    <b-col sm="4">
      <b-form-input  v-model="couponDetail.opt_value"></b-form-input>
    </b-col>
    <b-col sm="1">일</b-col>
  </b-row>
</div>
</template>

<script>

const moment = require("moment");

export default {
  props: {
    couponDetail:{
    },
    newFlag:null,
  },
  data() {
    return {
      couponnameVali:'couponnameVali',
      couponpubcntVali: 'couponpubcntVali',
    }
  },
  mounted: function() {
    var self = this;
    $(function() {
      $('input[name="expired"]').daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 2015,
        maxYear: parseInt(moment().format('YYYY'),15),
        end_date: moment().add(1, 'years').format('YYYY-MM-DD'),
        start_date: moment().format('YYYY-MM-DD'),
        locale: {
          "format": 'YYYY-MM-DD',
          "monthNames": [
            "1", "2", "3", "4", "5", "6",
            "7", "8", "9", "10", "11", "12"
          ],
        }
      }, function(start, end, label) {
        // self.couponDetail.start_date = start.format('YYYY-MM-DD');
        self.couponDetail.end_date = end.format('YYYY-MM-DD');
      });
    });
    this.couponDetail.start_date =  moment().format('YYYY-MM-DD');
    this.couponDetail.end_date =  moment().add(1, 'years').format('YYYY-MM-DD');
  },
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/coupon/CouponDetailFormModal.vue